import React from 'react';

import './error-message.css';

import { ErrorIcon } from '../../assets/svg/errorIcon';

export type ErrorMessageType = {
	title?: string;
	subtitle: string;
};

const ErrorMessage = ({ title, subtitle }: ErrorMessageType) => (
	<div className="errorMessage">
		<div className="errorMessage-content">
			<ErrorIcon className="errorMessage-icon" height={24} width={24} />
			<p>
				{title && <b>{title}</b>}
				{subtitle}
			</p>
		</div>
	</div>
);
export default ErrorMessage;
